/**
 * Hit again › Duplicate (user, 22/10/2026: "for Hit Again sends they need
 * to have option for duplicate button … enabled by default"): SMSWiser's
 * Duplicate option on hit-again drops, on by default (user, 22/10: "make it
 * simple … say that hit again will have the duplicate option"). It wins over
 * the container's Drop options and the list's own, for hit-again drops only.
 * A row of the hit-again grid (action/HitGrid).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { CopyPlus } from 'lucide-react';

import { Switch } from '@/components/ui';

import { HitRow } from './action/HitGrid';

const HINT = "SMSWiser's Duplicate option for hit-again drops. On by default.";

interface Props {
  duplicate: boolean;
  onDuplicate: (duplicate: boolean) => void;
}

export const HitDuplicateRow: FC<Props> = ({ duplicate, onDuplicate }) => (
  <HitRow
    icon={CopyPlus}
    label="Duplicate"
    hint={HINT}
    testId="hit-duplicate"
    note={
      <span key={String(duplicate)} className="block duration-300 animate-in fade-in-0 motion-reduce:animate-none">
        {duplicate ? 'Hit-again drops send with Duplicate on.' : 'Hit-again drops send with Duplicate off.'}
      </span>
    }
  >
    <Switch checked={duplicate} onCheckedChange={onDuplicate} aria-label="Duplicate" />
    <span className="text-[13px] text-foreground">{duplicate ? 'On' : 'Off'}</span>
  </HitRow>
);
